<template>
  <div>
    <div class="footer">
      <div class="footer-container">
        <el-row justify="space-between" style="flex">
          <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
            <div class="info">
              <img src="@/assets/images/footer1.png" class="img">
              <span class="title">
                品质服务
                <br>专业政策解读
              </span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
            <div class="info">
              <img src="@/assets/images/footer2.png" class="img">
              <span class="title">
              全程跟踪<br>全程服务
              </span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
            <div class="info">
              <img src="@/assets/images/footer3.png" class="img">
              <span class="title">
                风险共担
                <br>不成功可获赔偿
              </span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
            <div class="info">
              <img src="@/assets/images/footer4.png" class="img">
              <span class="title">
                免费售后
                <br>完善的售后体系
              </span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="record">
      <div class="footer-container">
        <p>业务：政府补贴申报、专项资金申报、高新技术企业入库申报、高新技术企业认定、高新技术企业税收优惠</p>
        <p>2019 © 上海龙软商务咨询服务有限公司 备案号：沪ICP备15027133号</p>
        <!-- <a href="http://www.dragonsoftgroup.com/" target="_blank">2019 © 上海龙软商务咨询服务有限公司 备案号：沪ICP备15027133号</a> -->
        <div class="item">
          <i class="iconfont icon-qq"></i>
          <i class="iconfont icon-weibo-circle"></i>
          <el-button type="text" @click="dialogVisible = true">
            <i class="iconfont icon-weixinmw"></i>
          </el-button>
          <el-dialog title="扫一扫添加微信" :visible.sync="dialogVisible" width="300px">
            <img src="@/assets/images/wx.jpg">
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return { dialogVisible: false };
  }
};
</script>

<style lang="scss" scoped>
.el-dialog {
  img {
    width: 100%;
  }
}
.el-button--text {
  color: #fff;
}
.iconfont {
  font-size: 20px;
}
.footer-container {
  width: 1000px;
  margin: 0 auto;
  color: #fff;
  a {
    color: #fff;
    font-size: 14px;
    text-decoration: none;
  }
}
.footer {
  background-color: #424c77;
  .info {
    font-size: 10px;
    padding: 12px 0;
    .img {
      margin-right: 10px;
      vertical-align: top;
    }
    .title {
      display: inline-block;
      margin: 4px 0;
    }
  }
}
.record {
  background-color: #20253a;
  padding: 20px 0;
  .footer-container {
    text-align: center;
    p {
      font-size: 14px;
      line-height: 30px;
    }
    .item {
      padding: 15px 0 5px;
      i {
        margin: 0 20px;
        cursor: pointer;
      }
    }
  }
}
@media screen and (max-width: 768px) {

  .footer-container {
    width: 100%;
  }
  .footer {
    padding: 0 10px;
    .el-row {
      margin-left: 30px;
    }
    .info {
      font-size: 10px;
      padding: 12px 0;
      .img {
        margin-right: 10px;
        vertical-align: top;
      }
      .title {
        display: inline-block;
        margin: 4px 0;
      }
    }
  }
  .record {
    padding: 20px 30px;
    .footer-container {
      text-align: left;
      .item {
        text-align: center;
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/footer.vue